import { MessageItem } from './MessageItem'
import { StreamingMessage } from './StreamingMessage'
import { ChatMessage, StreamStatus } from '../../state/types'

interface MessageListProps {
  messages: ChatMessage[]
  streamingMessage: string
  streamStatus: StreamStatus
  isLoading: boolean
}

export function MessageList({ messages, streamingMessage, streamStatus, isLoading }: MessageListProps) {
  const isStreaming = streamStatus === 'streaming'

  return (
    <>
      {messages.map((message) => (
        <MessageItem key={message.message_id} message={message} />
      ))}
      
      {/* Streaming message */}
      {isStreaming && streamingMessage && (
        <StreamingMessage content={streamingMessage} />
      )}
      
      {/* Loading indicator */}
      {(isLoading && !isStreaming) && (
        <div className="flex justify-start">
          <div className="bg-muted text-foreground rounded-lg p-3">
            <p className="text-sm">Narrio is typing...</p>
          </div>
        </div>
      )}
    </>
  )
} 